














import { Vue, Prop, Component } from 'vue-property-decorator';
import { Messages } from '../../constants/Messages';

@Component
export default class CameraPermissionErrorDialog extends Vue {
    @Prop() private isCameraPermission!: boolean;
    @Prop() private handleClose!: () => void;

    // TODO propsの値が初期値に使われた後はdataとpropsの間で値が同期されないので
    // getterとsetterを算出プロパティに定義して回避
    // 参考:https://qiita.com/simezi9/items/c27d69f17d2d08722b3a
    private get cameraPermission() {
        return this.isCameraPermission;
    }

    private set cameraPermission(v: boolean) {
        this.handleClose();
    }

    private get DialogMessage(): string {
        return Messages.Dialog.CameraPermissionError;
    }
}
